import React from "react";
import "../../../css/Common/Components/ContactUs/ConfirmCallback.css"; // custom styles

/**
 * NotificationPopup component displays a notification message in a popup overlay.
 *
 */
const NotificationPopup = ({ message, type, onClose }) => {
  return (
    <div className="notification-overlay">
      <div className={`popup-container ${type}`}>
        <span className="Label-Large-Bold">{message}</span>
        <button className="close-button Content" onClick={onClose}>
          X
        </button>
      </div>
    </div>
  );
};

export default NotificationPopup;
